var nurseslounge_myDashboard = {
    my_profile:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='my_profile']").click();
        });
    },
    my_profile_sub:function($params){
        nurseslounge_myDashboard_myProfile.init($params);
    },
    activity:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='activity']").click();
        });
    },
    activity_sub:function($params){
        nurseslounge_myDashboard_activity.init($params);
    },
    colleagues:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='colleagues']").click();
        });
    },
    colleagues_sub:function($params){
        nurseslounge_myDashboard_colleagues.init($params);
    },
    my_inbox:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='my_inbox']").click();
        });
    },
    my_inbox_sub:function($params){
        nurseslounge_myDashboard_myInbox.init($params);
    },
    jobs_near_me:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='jobs_near_me']").click();
        });
    },
    jobs_near_me_sub:function($params){
        nurseslounge_myDashboard_jobsNearMe.init($params);
    },
    degrees_for_me:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='degrees_for_me']").click();
        });
    },
    degrees_for_me_sub:function($params){
        nurseslounge_myDashboard_degreesForMe.init($params);
    },
    my_articles:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='my_articles']").click();
        });
    },
    my_articles_sub:function($params){
        nurseslounge_myDashboard_myArticles.init($params);
    },
    continuing_education:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='continuing_education']").click();
        });
    },
    continuing_education_sub:function($params){
        nurseslounge_myDashboard_continuingEducation.init($params);
    },
    my_calendar:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='my_calendar']").click();
        });
    },
    my_calendar_sub:function($params){
        nurseslounge_myDashboard_myCalendar.init($params);
    },
    schedule:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='schedule']").click();
        });
    },
    schedule_sub:function($params){
        nurseslounge_myDashboard_schedule.init($params);
    },
    my_float_pool:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='my_float_pool']").click();
        });
    },
    my_float_pool_sub:function($params){
        nurseslounge_myDashboard_my_float_pool.init($params);
    },
    my_credentials_vault:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='my_credentials_vault']").click();
        });
    },
    my_credentials_vault_sub:function($params){
        nurseslounge_myDashboard_myCredentialsVault.init($params);
    },
    manage_my_lounges:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='manage_my_lounges']").click();
        });
    },
    manage_my_lounges_sub:function($params){
        nurseslounge_myDashboard_manageMyLounges.init($params);
    },
    preceptors:function($params){
        nurseslounge_myDashboard_recommendations.init($params);
        nurseslounge_myDashboard_accountSettings.init($params);
        nurseslounge_myDashboard_camera.init($params);
        nurseslounge_myDashboard.submenu($params, function(){
            $(".nav-underline a[data-id='preceptors']").click();
        });
    },
    preceptors_sub:function($params){
        nurseslounge_myDashboard_preceptors.init($params);
    },
    submenu:function($params, cback){
        $(".nav-underline a").unbind().click(function(){
            $(".nav-underline a").removeClass('active');
            var $previewProfile = libs.memoryGet('preview_profile');
            var $userId = libs.memoryGet('user_id');
            if($previewProfile && $previewProfile == 1){
                router.navigate("profile/"+$userId);
            }else{
                nurseslounge_myDashboard.submenu_open(this, $(this).data('url'),  $(this).data('id')+'_sub', $params)
            }
        });
        nurseslounge_myDashboard.menu_selector();
        nurseslounge_myDashboard.menu_scroll();
        var $notification = nurseslounge_myDashboard.notification_open($params, window.location.href.toString());
        if($notification.valid){
            var $open = '';
            switch($params.notification_type){
                case  'myInbox':{$open = 'my_inbox';break;}
                case  'myPublishedArticle':{$open = 'my_articles';break;}
                case  'myCalendar':{$open = 'my_calendar';break;}
            }
            $(".nav-underline a").each(function(){
                var $that = $(this);
                if($that.data('id') == $open){
                    $that.addClass('active')
                }
            });
            $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
            libs.subrender('/myDashboard/'+$notification.module, 'nurseslounge_myDashboard', $open+'_sub', $params, 'POST');
            cback();
        }else{
            cback();
        }
    },
    submenu_open:function($this, $url, $module, $params){
        $params = $.extend({}, $params, {
            user_id:libs.memoryGet('user_id'),
            my_room_id:libs.memoryGet('my_room_id'),
            notification_key:null,
            notification_type:null,
            notification_type_key:null,
        });
        $($this).addClass('active');
        router.pause();
        router.navigate($url);
        router.resume();
        $params = $.extend({}, $params, {user_id:libs.memoryGet('user_id')});
        libs.subrender($url, 'nurseslounge_myDashboard', $module, $params, 'POST');
    },
    notification_open:function($params, $location){
        var $notification = {};
        var $notificationData = [];
        if($params && $params.notification_key){$notificationData.push($params.notification_key);}
        if($params && $params.notification_type){$notificationData.push($params.notification_type);}
        if($params && $params.notification_type_key){$notificationData.push($params.notification_type_key);}
        $notification.valid = $notificationData.length == 3;
        $notification.url = $location.replace('/notification/'+$notificationData.join('/'), '');
        var $url = $notification.url.split('/');
        $notification.module = $url[4];
        return $notification;
    },
    menu_selector:function(){
        libs.globalUrl();
    },
    menu_scroll:function(){
        var $nursesLounge = $("#nurseslounge-lounge");
        var $nav = $nursesLounge.find(".nav.nav-underline");
        var $maxScrollLeft = $nav[0].scrollWidth - $nav[0].clientWidth;
        var $scrollLeft;
        var $scrollerLeft =  $nursesLounge.find(".nav-scroller-left");
        var $scrollerRight =  $nursesLounge.find(".nav-scroller-right");
        var $binding;
        $scrollerLeft.unbind().click(function(){
            $maxScrollLeft = $nav[0].scrollWidth - $nav[0].clientWidth;
            $nav.animate({
                scrollLeft: '-=450',//0
            }, 800, "linear", function() {
                $scrollLeft = $nav.scrollLeft();
                try{
                    clearTimeout($binding);
                }catch (e) {

                }
                $binding = setTimeout(function(){
                    if($scrollLeft < 10){
                        $scrollerLeft.fadeOut();
                    }else{
                        $scrollerLeft.fadeIn();
                    }
                    if($scrollLeft > ($maxScrollLeft-10)){
                        $scrollerRight.fadeOut();
                    }else{
                        $scrollerRight.fadeIn();
                    }
                });
            });
        });
        $scrollerRight.unbind().click(function(){
            $maxScrollLeft = $nav[0].scrollWidth - $nav[0].clientWidth;
            $nav.animate({
                scrollLeft: '+=450',//$maxScrollLeft
            }, 800, "linear", function() {
                $scrollLeft = $nav.scrollLeft();
                try{
                    clearTimeout($binding);
                }catch (e) {

                }
                $binding = setTimeout(function(){
                    if($scrollLeft < 10){
                        $scrollerLeft.fadeOut();
                    }else{
                        $scrollerLeft.fadeIn();
                    }
                    if($scrollLeft > ($maxScrollLeft-10)){
                        $scrollerRight.fadeOut();
                    }else{
                        $scrollerRight.fadeIn();
                    }
                });
            });
        });
    }
};
